<template>
    <div class="animated fadeIn">
      <b-card>
        <div slot="header">
          {{ this.$route.meta.title }}
          <div class="card-header-actions">
            <!-- <button
              class="btn btn-primary mr-1"
              @click="showFilter = !showFilter"
            >
              <i class="fa fa-filter"></i> Filter
            </button> -->
            <button class="btn btn-primary mr-1" @click="close()">
              <i class="fa fa-close"></i> {{ $t("close") }}
            </button>
          </div>
        </div>
        <b-row>
          <b-col lg="8">
            <b-input-group>
              <b-input-group-prepend > 
                <label style="min-width: 150px">Tgl. Collection Report</label>
              </b-input-group-prepend>
              <b-form-input v-model="tblData.tgl" 
              type="date" class="ml-3" 
              :max="maxdtreport"
              :state="!$v.tblData.tgl.$error"></b-form-input>
              <b-input-group-append>
                <label class="p-1">Project</label>
              </b-input-group-append>
              <b-form-select v-model="tblData.pjxkey" :plain="true" :options="projectsFilt"></b-form-select>  
              <b-button
                  variant="success"
                  @click="processCollectionReport('report')"
                  class="ml-3"
                >
                  <i class="fa fa-play"></i> Proses
                </b-button>
                <b-button variant="primary ml-2" @click="exportxlsreportbyloan()">
                  <i class="fa fa-file-excel-o"></i>Export
                </b-button>
            </b-input-group>
          </b-col>
        </b-row>
  
        <b-card no-body class="mb-0">
          <b-table
            class="mb-0"
            ref="table"
            outlined
            responsive
            striped
            hover
            style="font-size: smaller"
            :items="tblData.items"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit"
                  :filter="filterInput"
                  :filterIncludedFields="filterOn"
                  @filtered="onFiltered"                
            :busy="isBusy"
            show-empty
          >
            <template v-slot:cell(index)="data">{{((tblData.page-1)*tblData.limit)+(data.index + 1) }}</template>
            <template v-slot:cell(installmentEndDate)="data">{{
              data.item.installmentEndDate | moment("DD/MM/YY")
            }}</template>
            <template v-slot:cell(paid_date)="data">{{
              data.item.paid_date | moment("DD/MM/YY")
            }}</template>
            <template v-slot:cell(loan_amount)="data">{{
              data.item.loan_amount | numFormat("0,0.00")
            }}</template>
            <template v-slot:cell(total_repayment)="data">{{
              data.item.total_repayment | numFormat("0,0.00")
            }}</template>
            <template v-slot:cell(principal)="data">{{
              data.item.principal | numFormat("0,0.00")
            }}</template>
            <template v-slot:cell(interest_repaid)="data">{{
              data.item.interest_repaid | numFormat("0,0.00")
            }}</template>
            <template v-slot:cell(outstanding)="data">{{
              data.item.outstanding | numFormat("0,0.00")
            }}</template>
            <template v-slot:cell(interest_estimate)="data">{{
              data.item.interest_estimate | numFormat("0,0.00")
            }}</template>
           
            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(empty)="data">
              <h4>{{ data.emptyText }}</h4>
            </template>
            <template v-slot:cell(emptyfiltered)="data">
              <h4>{{ data.emptyFilteredText }}</h4>
            </template>
            
          </b-table>
        </b-card>
        <b-row class="m-1">
          <b-col lg="6">            
            <b-row v-if="(filterShow=='Hide')">
                  <b-input-group size="sm">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                        <b-input-group-prepend> <span class="pr-2">
                            <b> {{ filterShow }}</b>  Filter </span>
                        </b-input-group-prepend>
                      <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group size="sm" class="ml-4">
                      <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
                      </b-input-group-prepend>
                      <b-form-checkbox-group v-model="filterOn" class="mt-1">
                        <b-form-checkbox value="no_agreement">Agreement No.</b-form-checkbox>
                        <b-form-checkbox value="CustName">Debitur Name</b-form-checkbox>
                        <b-form-checkbox value="KOL_EOM">Collectability</b-form-checkbox>
                        <b-form-checkbox value="DefaultStat">Default (WO) status</b-form-checkbox>
                      </b-form-checkbox-group>
                  </b-input-group>
                  <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
            </b-row>
            <b-row v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch >
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-row>
          </b-col>
          <b-col lg="6">
            <div style="display: flex;margin:0;padding:0;">
                <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblData.page - 1) * tblData.limit + 1}}
                    to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                    of {{tblData.total}} ,   <span class="mr-1">limit per page :</span> 
                    <select  v-model="tblData.limit"  style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>                            
                      <option>25</option>
                      <option>30</option>                            
                      <option>40</option>                            
                      <option>50</option>                            
                      <option>60</option>                            
                      <option>70</option>                            
                      <option>80</option>                            
                      <option>90</option>                            
                    </select>
                </div>
                <div>
                    <b-pagination  class="ml-1" 
                      align="left"
                      :total-rows="tblData.total"
                      :per-page="tblData.limit"
                      v-model="tblData.page"
                    ></b-pagination>
                </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading> 
      Background Process : {{backgroundprocessreport }}      
    </div>
  </template>
  
  <script>
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import { validationMixin } from "vuelidate";
  import { required} from "vuelidate/lib/validators";
  import moment from "moment";
  import myNumber from "../../components/my-number";
  import toastr from "mini-toastr";
  import collection from '../../apis/collection';
  import crud from "../../apis/crud";

  toastr.init();
  export default {
    components: { myNumber, Loading },
      mixins: [validationMixin],
    validations: {
      tblData:{
        tgl:{required}
      }
    },
    data() {
      return {
        showFilter: true,
        isBusy: false,
        isLoading:false,
        toExport:false,
        maxdtreport : moment(this.$store.state.timeServer).subtract(1,'days').format('YYYY-MM-DD'),
        projectsFilt:[{
          value:'',text:'-- ALL --'
        }],
        tblData: {
          items: [],
          tgl:'',
          page: 1,
          limit: 15,
          total: 0,
          sortBy: "no_kontrak",
          sortDesc: false,
          date:'',pjxkey:''
          
        },
        filterShow:'Show',
        filter: null,
        filterInput: null,
        filterOn: ['no_agreement','CustName'],   
      };
    },
    computed: {
       invalidTblData() {
        this.$v.tblData.$touch();
        return this.$v.tblData.$invalid;
      },
      tblFields() {
        const fields = [
          {
            key: "index",
            label: "#",
            thStyle: "width:100px",
          },
          {
            key: "customerID",
            label: "Customer ID",
            thStyle: "width:140px",
            sortable: true,
          },
          {
            key: "debtorFullName",
            label: "Debitur Name",
            thClass: "text-center",
            sortable: true,
          },
          {
            key: "loan_id",
            label: "Loan ID",
            sortable: true,
          },
          {
            key: "installmentEndDate",
            label: "Maturity",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "paid_date",
            label: "Paid Date",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "loan_amount",
            label: "Disbursement Amount",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "total_repayment",
            label: "Repayment Received",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "principal",
            label: "Repayement Principal",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "interest_repaid",
            label: "Repayement Interest",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "outstanding",
            label: "Principal OS",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "interest_estimate",
            label: "Interest Estimate",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "dpd",
            label: "DOD",
            thClass: "text-center",
            tdClass: "text-left",
            sortable: true,
          }
        ];
  
  
        return fields;
      },
      dimCol() {
        return this.tblData.DimCol;
      },
      backgroundprocessreport() {
      let progessupload = this.$store.state.backgroundprocessreport.collectionreportbyloan;
      if(progessupload=='done'){
        this.isLoading = false;
        if(this.toExport){
          this.exportxlsreportbyloan();
        }else{
          this.getCollectionReport();
        }
        
      }
      return progessupload;
    },
    },
    watch:{
      // filterShow: function(newval) {
      //   setTimeout(() => {
      //           this.filter=''
      //   }, 200);
      // },
      // filter: function(newval) {
      //   // this.isBusy=true;
      //   setTimeout(() => {
      //         this.filterInput=newval;
      //   }, 800);
      // }
    }, 
    async created() {
      const [projects] = await Promise.all([crud.list({
        tablename: 'project',
        page: 1,
        limit: 10000,
        total: 0,
        sortBy: 'pjxname',
        sortDesc: false,
      })]);

      projects.forEach(tp => {
        this.projectsFilt.push({ value: tp.pjxkey, text: tp.pjxname })
      });

      this.$store.commit('backgroundprocessreport',{key:'collectionreportbyloan',value:'idle'});

    },
    methods: {
      onFiltered(filteredItems) {
        this.tblData.total = filteredItems.length;
        this.tblData.page = 1;
      },     
      clearFilter() {
            //this.filterOn= []   
            this.filter= '';   
      } ,
  
      async processCollectionReport(val) {
        try {
          if(!this.invalidTblData){
            this.isLoading = true;
            if(val=='export'){
              this.toExport = true;
            }
            await collection.processreportbyloan(this.tblData);
            toastr.success('Data Will Process On Background Service. Please Wait !');
          }
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      },
      async getCollectionReport() {
        try {
          if(!this.invalidTblData){
            this.isBusy=true;
            const list = await collection.reportbyloan(this.tblData);
            this.tblData.items = list;
            this.tblData.total = list.length;
            this.isBusy=false;
            this.$store.commit('backgroundprocessreport',{key:'collectionreportbyloan',value:'idle'})
          }
        } catch (error) {
          console.log("error : ", error);
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      },
      async exportxlsreportbyloan() {
        try {
          if(!this.invalidTblData){
            this.isLoading = true;
            await collection.exportxlsreportbyloan(this.tblData);
            this.isLoading = false;
            this.$store.commit('backgroundprocessreport',{key:'collectionreportbyloan',value:'idle'})
          }
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      },
      close() {
        router.push("home");
      },
    },
  };
  </script>